import React, { useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useApiAuth } from "../hooks/useApiAuth";
import { useSearch } from "../contexts/SearchContext";
import { useGlobalSearch } from "../contexts/GlobalSearchContext";
import ClientsAdmin from "./admin/ClientsAdmin";
import ProjectsAdmin from "./admin/ProjectsAdmin";
import ServiceTypesAdmin from "./admin/ServiceTypesAdmin";
import WeeksAdmin from "./admin/WeeksAdmin";
import ProjectStatusAdmin from "./admin/ProjectStatusAdmin";
import PeopleAdmin from "./admin/PeopleAdmin";
import RolesAdmin from "./admin/RolesAdmin";

const AdminPage: React.FC = () => {
  const { isApiReady, isLoading: authLoading, error: authError } = useApiAuth();
  const { setSearchTerm } = useSearch();
  const { clearGlobalSearch } = useGlobalSearch();
  const [activeTab, setActiveTab] = useState("clients");

  // Handle tab change and clear search
  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey);
    // Clear both local and global search when switching tabs
    setSearchTerm("");
    clearGlobalSearch();
  };

  const adminTabs = [
    {
      key: "clients",
      label: "Clients",
      icon: "pi pi-users",
      component: <ClientsAdmin />,
    },
    {
      key: "projects",
      label: "Projects",
      icon: "pi pi-briefcase",
      component: <ProjectsAdmin />,
    },
    {
      key: "people",
      label: "People",
      icon: "pi pi-user",
      component: <PeopleAdmin />,
    },
    {
      key: "roles",
      label: "Roles",
      icon: "pi pi-shield",
      component: <RolesAdmin />,
    },
    {
      key: "project-status",
      label: "Project Status",
      icon: "pi pi-flag",
      component: <ProjectStatusAdmin />,
    },
    {
      key: "service-types",
      label: "Service Types",
      icon: "pi pi-cog",
      component: <ServiceTypesAdmin />,
    },
    {
      key: "weeks",
      label: "Weeks",
      icon: "pi pi-calendar",
      component: <WeeksAdmin />,
    },
  ];

  if (!isApiReady) {
    return (
      <div className="page-container">
        <Card title="Admin">
          <div className="flex justify-content-center">
            {authLoading ? (
              <div>Loading authentication...</div>
            ) : authError ? (
              <div className="text-red-500">
                Authentication error: {authError}
              </div>
            ) : (
              <div>Waiting for authentication...</div>
            )}
          </div>
        </Card>
      </div>
    );
  }

  const currentTabData =
    adminTabs.find((tab) => tab.key === activeTab) || adminTabs[0];

  return (
    <div className="page-container">
      {/* Custom navigation */}
      <div className="admin-nav mb-4">
        <div className="flex flex-wrap gap-2">
          {adminTabs.map((tab) => (
            <Button
              key={tab.key}
              label={tab.label}
              icon={tab.icon}
              className={`p-button-sm ${
                activeTab === tab.key
                  ? "p-button-primary"
                  : "p-button-outlined p-button-secondary"
              }`}
              onClick={() => handleTabChange(tab.key)}
            />
          ))}
        </div>
      </div>
      <Card>
        {/* Content area */}
        {currentTabData.component}
      </Card>
    </div>
  );
};

export default AdminPage;
